<!--
 * @Author       : yannisyu
 * @Date         : 2022-10-14 19:36:46
 * @LastEditors  : yannisyu
 * @LastEditTime : 2022-10-14 19:36:46
 * @Description  : 
 * @FilePath     : /fe-eshotel/src/pages/home/components/popover.mpx
-->
<template>
  <view class="popover-dawn-wapper">
    <es-icon name="exclamation-circle-filled" class="popover-icon" size="14" />
    {{ text }}
  </view>
</template>

<script>
  import { createComponent } from '@didi/es-mpx-creator'

  createComponent({
    props: {
      text: {
        type: String,
        value: ''
      }
    }
  })
</script>

<style scoped lang="stylus">
  .popover-dawn-wapper
    height 64rpx
    color #FF6F2A
    font-size 24rpx
    padding-left 24rpx
    font-weight 400
    display flex
    align-items center
    background rgba(255, 244, 238, 0.5)
    border 2rpx solid rgba(255, 111, 42, 0.16)
    border-radius 16rpx
    margin 0 32rpx
  .popover-icon
    padding-right 4px
</style>
<script name='json'>
  module.exports = {
    component: true,
  }
</script>
